import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { ChuyenKhoNoiBoMaster } from '../kho-chuyen-kho-noi-bo-page-model/kho-nhap-kho-page.model';

const API_ROOT_URL = environment.ApiRoot + '/kho';

@Injectable()
export class KhoCKNBPageService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	lastData$: BehaviorSubject<ChuyenKhoNoiBoMaster[]> = new BehaviorSubject([]);
	dataNew$: BehaviorSubject<number[]> = new BehaviorSubject([]);
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;

	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }

	/*-------------------------------GET Method----------------------------- */
	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/cknb_list', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getItemById(Id): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/cknb_get_detail?Id=${Id}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getDataVTK(IdKho: number, IdHH: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/cknb_get_vtk_info?IdKho=${IdKho}&IdHH=${IdHH}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getDSVTK(IdKho: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/dungchung' + `/ViTriKho_List?IdKho=${IdKho}` ;
		return this.http.get<any>(url , { headers: httpHeaders });
	}
	getDSPallet(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  `${API_ROOT_URL}` + '/pallet_list_all_nk' ;
		return this.http.get<any>(url , { headers: httpHeaders });
	}
	listKhoChuyen(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + `/danhmuc/KhoTonKho_List?idhh=${itemId}`;;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */
	

	/*-------------------------------POST Method---------------------------- */
	add(item: ChuyenKhoNoiBoMaster): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<ChuyenKhoNoiBoMaster>(API_ROOT_URL+'/cknb_add', item, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */
	downloadExcel(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<Blob>(API_ROOT_URL + '/CKNB_ExportExcel', {
		  headers: httpHeaders,
		  responseType: 'blob' as 'json'
		});
	}
	listSoLo(idkho,idhh): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + `/danhmuc/GetAllSoLoByIdkho_Idhh?idkho=${idkho}&&idhh=${idhh}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
}
